<template>
  <div class="page flex-col">
    <div class="box_51 flex-row">
      <div class="box_1 flex-col">
        <div class="box_52 flex-row justify-between">
          <img
            class="thumbnail_1"
            referrerpolicy="no-referrer"
            src="./assets/img/FigmaDDSSlicePNG7bf62594a5a733f050b58b304a17713c.png"
          />
          <div class="image-wrapper_1 flex-col">
            <img
              class="thumbnail_2"
              referrerpolicy="no-referrer"
              src="./assets/img/FigmaDDSSlicePNG4c5c487f0013fe392d2fb7a2869509e3.png"
            />
          </div>
        </div>
        <div class="image-wrapper_23 flex-row justify-between">
          <img
            class="thumbnail_3"
            referrerpolicy="no-referrer"
            src="./assets/img/FigmaDDSSlicePNGa328d4e7454e4010047f1e40db33e022.png"
          />
          <img
            class="thumbnail_4"
            referrerpolicy="no-referrer"
            src="./assets/img/FigmaDDSSlicePNG9bf204517d49598a0e85c27a3c3797d5.png"
          />
        </div>
      </div>
      <div class="box_2 flex-col">
        <div class="group_18 flex-row justify-between">
          <div class="image-wrapper_3 flex-col">
            <img
              class="thumbnail_5"
              referrerpolicy="no-referrer"
              src="./assets/img/FigmaDDSSlicePNGd0fe271de7ffad3df6d5321753549c25.png"
            />
          </div>
          <div class="image-wrapper_4 flex-col">
            <img
              class="thumbnail_6"
              referrerpolicy="no-referrer"
              src="./assets/img/FigmaDDSSlicePNG8c264eb505c830a7d6db3f54d25bc36c.png"
            />
          </div>
          <img
            class="thumbnail_7"
            referrerpolicy="no-referrer"
            src="./assets/img/FigmaDDSSlicePNGc2bd240c923633de8b123e43077399d2.png"
          />
          <img
            class="thumbnail_8"
            referrerpolicy="no-referrer"
            src="./assets/img/FigmaDDSSlicePNGbddf8383dc635787f1cc6edbb4aa6ac8.png"
          />
          <img
            class="thumbnail_9"
            referrerpolicy="no-referrer"
            src="./assets/img/FigmaDDSSlicePNG2fbd0e2160458aea489298b6ce94d4c3.png"
          />
          <img
            class="thumbnail_10"
            referrerpolicy="no-referrer"
            src="./assets/img/FigmaDDSSlicePNG3bb9f96a1f089d6cd19780abc99cb550.png"
          />
        </div>
        <div class="group_19 flex-row justify-between">
          <div class="image-wrapper_5 flex-col">
            <img
              class="thumbnail_11"
              referrerpolicy="no-referrer"
              src="./assets/img/FigmaDDSSlicePNG0ffad68f6498e34959139dd40699e115.png"
            />
          </div>
          <img
            class="thumbnail_12"
            referrerpolicy="no-referrer"
            src="./assets/img/FigmaDDSSlicePNG81c3f5c1a046cb82180ed2f809f04840.png"
          />
          <img
            class="thumbnail_13"
            referrerpolicy="no-referrer"
            src="./assets/img/FigmaDDSSlicePNG21ab123c81b85b0292aa87a9fd067184.png"
          />
          <img
            class="thumbnail_14"
            referrerpolicy="no-referrer"
            src="./assets/img/FigmaDDSSlicePNG791ad1cec6cdb2d7e93432a55c6efa26.png"
          />
          <img
            class="thumbnail_15"
            referrerpolicy="no-referrer"
            src="./assets/img/FigmaDDSSlicePNGe60b9d3f1953c3ed27111dc2790465aa.png"
          />
          <img
            class="thumbnail_16"
            referrerpolicy="no-referrer"
            src="./assets/img/FigmaDDSSlicePNGf4665b518db90196149e17a8569dba56.png"
          />
        </div>
      </div>
      <div class="box_5 flex-col">
        <div class="group_20 flex-row justify-between">
          <div class="image-wrapper_6 flex-col">
            <img
              class="thumbnail_17"
              referrerpolicy="no-referrer"
              src="./assets/img/FigmaDDSSlicePNG0ffad68f6498e34959139dd40699e115.png"
            />
          </div>
          <div class="image-wrapper_7 flex-col">
            <img
              class="thumbnail_18"
              referrerpolicy="no-referrer"
              src="./assets/img/FigmaDDSSlicePNGd0fe271de7ffad3df6d5321753549c25.png"
            />
          </div>
        </div>
        <div class="box_7 flex-row">
          <img
            class="thumbnail_19"
            referrerpolicy="no-referrer"
            src="./assets/img/FigmaDDSSlicePNG0ffad68f6498e34959139dd40699e115.png"
          />
          <span class="text_1">首页</span>
        </div>
        <div class="box_8 flex-row">
          <img
            class="thumbnail_20"
            referrerpolicy="no-referrer"
            src="./assets/img/FigmaDDSSlicePNGd0fe271de7ffad3df6d5321753549c25.png"
          />
          <span class="text_2">首页</span>
        </div>
      </div>
      <div class="section_11 flex-col justify-between">
        <div class="image-wrapper_8 flex-col">
          <img
            class="thumbnail_21"
            referrerpolicy="no-referrer"
            src="./assets/img/FigmaDDSSlicePNG3b6a0557148b9dbd234b3f24d811b8b7.png"
          />
        </div>
        <div class="image-wrapper_9 flex-col">
          <img
            class="thumbnail_22"
            referrerpolicy="no-referrer"
            src="./assets/img/FigmaDDSSlicePNG3b6a0557148b9dbd234b3f24d811b8b7.png"
          />
        </div>
      </div>
      <div class="section_12 flex-col justify-between">
        <div class="image-wrapper_10 flex-col">
          <img
            class="thumbnail_23"
            referrerpolicy="no-referrer"
            src="./assets/img/FigmaDDSSlicePNGbea23f8578d665e2cf127d759f03ae5d.png"
          />
        </div>
        <div class="image-wrapper_11 flex-col">
          <img
            class="thumbnail_24"
            referrerpolicy="no-referrer"
            src="./assets/img/FigmaDDSSlicePNGbea23f8578d665e2cf127d759f03ae5d.png"
          />
        </div>
      </div>
      <div class="section_13 flex-col justify-between">
        <div class="text-wrapper_1 flex-col"><span class="text_3">1</span></div>
        <div class="text-wrapper_2 flex-col"><span class="text_4">1</span></div>
      </div>
      <div class="section_14 flex-col justify-between">
        <div class="text-wrapper_3 flex-col"><span class="text_5">2</span></div>
        <div class="text-wrapper_4 flex-col"><span class="text_6">2</span></div>
      </div>
      <div class="section_15 flex-col justify-between">
        <div class="text-wrapper_5 flex-col"><span class="text_7">3</span></div>
        <div class="text-wrapper_6 flex-col"><span class="text_8">3</span></div>
      </div>
      <div class="section_16 flex-col justify-between">
        <div class="text-wrapper_7 flex-col"><span class="text_9">4</span></div>
        <div class="text-wrapper_8 flex-col"><span class="text_10">4</span></div>
      </div>
      <div class="section_17 flex-col justify-between">
        <div class="image-wrapper_12 flex-col">
          <img
            class="thumbnail_25"
            referrerpolicy="no-referrer"
            src="./assets/img/FigmaDDSSlicePNG5b777fcbb34e1d24ce0cd873fe48b7a7.png"
          />
        </div>
        <div class="image-wrapper_13 flex-col">
          <img
            class="thumbnail_26"
            referrerpolicy="no-referrer"
            src="./assets/img/FigmaDDSSlicePNG5b777fcbb34e1d24ce0cd873fe48b7a7.png"
          />
        </div>
      </div>
      <div class="section_18 flex-col justify-between">
        <div class="text-wrapper_9 flex-col"><span class="text_11">10</span></div>
        <div class="text-wrapper_10 flex-col"><span class="text_12">10</span></div>
      </div>
      <div class="section_19 flex-col justify-between">
        <div class="image-wrapper_14 flex-col">
          <img
            class="thumbnail_27"
            referrerpolicy="no-referrer"
            src="./assets/img/FigmaDDSSlicePNG9fa2e832dd7083ca96fca5e8a21769b1.png"
          />
        </div>
        <div class="image-wrapper_15 flex-col">
          <img
            class="thumbnail_28"
            referrerpolicy="no-referrer"
            src="./assets/img/FigmaDDSSlicePNG9fa2e832dd7083ca96fca5e8a21769b1.png"
          />
        </div>
      </div>
      <div class="section_20 flex-col justify-between">
        <div class="image-wrapper_16 flex-col">
          <img
            class="thumbnail_29"
            referrerpolicy="no-referrer"
            src="./assets/img/FigmaDDSSlicePNG2cde8f1c9d63da92e8588ea67f28c534.png"
          />
        </div>
        <div class="image-wrapper_17 flex-col">
          <img
            class="thumbnail_30"
            referrerpolicy="no-referrer"
            src="./assets/img/FigmaDDSSlicePNG2cde8f1c9d63da92e8588ea67f28c534.png"
          />
        </div>
      </div>
    </div>
    <div class="box_53 flex-row justify-between">
      <div class="section_2 flex-row justify-around">
        <div class="block_3 flex-col">
          <div class="image-wrapper_18 flex-col">
            <img
              class="label_1"
              referrerpolicy="no-referrer"
              src="./assets/img/FigmaDDSSlicePNGe909db0921cf6fdf268e6d7557656c70.png"
            />
          </div>
          <div class="block_4 flex-col">
            <span class="text_13">常用</span>
            <div class="image-wrapper_19 flex-col">
              <img
                class="thumbnail_31"
                referrerpolicy="no-referrer"
                src="./assets/img/FigmaDDSSlicePNG0ffad68f6498e34959139dd40699e115.png"
              />
            </div>
            <img
              class="thumbnail_32"
              referrerpolicy="no-referrer"
              src="./assets/img/FigmaDDSSlicePNG8c264eb505c830a7d6db3f54d25bc36c.png"
            />
          </div>
          <span class="text_14">个人</span>
          <img
            class="thumbnail_33"
            referrerpolicy="no-referrer"
            src="./assets/img/FigmaDDSSlicePNGc2bd240c923633de8b123e43077399d2.png"
          />
          <img
            class="thumbnail_34"
            referrerpolicy="no-referrer"
            src="./assets/img/FigmaDDSSlicePNGbddf8383dc635787f1cc6edbb4aa6ac8.png"
          />
          <img
            class="thumbnail_35"
            referrerpolicy="no-referrer"
            src="./assets/img/FigmaDDSSlicePNG2fbd0e2160458aea489298b6ce94d4c3.png"
          />
          <img
            class="thumbnail_36"
            referrerpolicy="no-referrer"
            src="./assets/img/FigmaDDSSlicePNG3bb9f96a1f089d6cd19780abc99cb550.png"
          />
          <img
            class="label_2"
            referrerpolicy="no-referrer"
            src="./assets/img/FigmaDDSSlicePNG9bcfe6d982522340d018b80cfc043610.png"
          />
        </div>
        <div class="block_5 flex-col">
          <div class="group_1 flex-row justify-between">
            <div class="image-text_25 flex-row justify-between">
              <img
                class="label_3"
                referrerpolicy="no-referrer"
                src="./assets/img/FigmaDDSSlicePNGe909db0921cf6fdf268e6d7557656c70.png"
              />
              <span class="text-group_1">虹猫AI</span>
            </div>
            <img
              class="label_4"
              referrerpolicy="no-referrer"
              src="./assets/img/FigmaDDSSlicePNGedbf187e9e48252ea957d23ecd9f69a5.png"
            />
          </div>
          <div class="group_2 flex-col">
            <span class="text_15">常用</span>
            <div class="group_3 flex-row">
              <div class="image-text_26 flex-row justify-between">
                <img
                  class="thumbnail_37"
                  referrerpolicy="no-referrer"
                  src="./assets/img/FigmaDDSSlicePNG0ffad68f6498e34959139dd40699e115.png"
                />
                <span class="text-group_2">首页</span>
              </div>
            </div>
            <div class="image-text_27 flex-row justify-between">
              <img
                class="thumbnail_38"
                referrerpolicy="no-referrer"
                src="./assets/img/FigmaDDSSlicePNG4fbea3edc86295aec7ce2d522f01e5dc.png"
              />
              <span class="text-group_3">内容创作</span>
            </div>
          </div>
          <span class="text_16">个人</span>
          <div class="image-text_28 flex-row justify-between">
            <img
              class="thumbnail_39"
              referrerpolicy="no-referrer"
              src="./assets/img/FigmaDDSSlicePNG30efa98cc810128b2bb9dd4e02745011.png"
            />
            <span class="text-group_4">我的资产</span>
          </div>
          <div class="image-text_29 flex-row justify-between">
            <img
              class="thumbnail_40"
              referrerpolicy="no-referrer"
              src="./assets/img/FigmaDDSSlicePNGb336440d620eb8699173de2c0ba462e7.png"
            />
            <span class="text-group_5">爆款书单</span>
          </div>
          <div class="image-text_30 flex-row justify-between">
            <img
              class="thumbnail_41"
              referrerpolicy="no-referrer"
              src="./assets/img/FigmaDDSSlicePNG3fcb4facd2441139a156399ff2fa3cfb.png"
            />
            <span class="text-group_6">账号托管</span>
          </div>
          <div class="image-text_31 flex-row justify-between">
            <img
              class="thumbnail_42"
              referrerpolicy="no-referrer"
              src="./assets/img/FigmaDDSSlicePNG9d42c43a0f1573fded63f4a7e37ce426.png"
            />
            <span class="text-group_7">商城</span>
          </div>
          <div class="group_4 flex-row justify-between">
            <div class="image-text_32 flex-row justify-between">
              <img
                class="label_5"
                referrerpolicy="no-referrer"
                src="./assets/img/FigmaDDSSlicePNG9bcfe6d982522340d018b80cfc043610.png"
              />
              <div class="text-group_11 flex-col justify-between">
                <span class="text_17">admin</span>
                <div class="text-wrapper_11">
                  <span class="text_18">邀请码：</span>
                  <span class="text_19">2654</span>
                </div>
              </div>
            </div>
            <span class="text_20">退出</span>
          </div>
          <div class="text-wrapper_22 flex-row justify-between">
            <span class="text_21">隐私政策</span>
            <span class="text_22">免责条款</span>
          </div>
        </div>
      </div>
      <div class="group_21 flex-col">
        <div class="section_4 flex-row">
          <div class="text-wrapper_13 flex-col"><span class="text_23">按钮</span></div>
          <div class="text-wrapper_14 flex-col"><span class="text_24">按钮</span></div>
          <div class="text-wrapper_15 flex-col"><span class="text_25">按钮</span></div>
        </div>
        <div class="group_22 flex-row justify-between">
          <div class="box_19 flex-row">
            <span class="text_26">下拉</span>
            <img
              class="thumbnail_43"
              referrerpolicy="no-referrer"
              src="./assets/img/FigmaDDSSlicePNG90ad9bcb7f86cb00185a4fb60103e0f0.png"
            />
          </div>
          <div class="box_20 flex-row justify-between">
            <span class="text_27">最热</span>
            <img
              class="thumbnail_44"
              referrerpolicy="no-referrer"
              src="./assets/img/FigmaDDSSlicePNGa9089df36d5077b4d0fd962afebb0485.png"
            />
          </div>
        </div>
        <div class="group_23 flex-row justify-between">
          <div class="group_5 flex-col">
            <div class="text-wrapper_16 flex-col"><span class="text_28">选项一</span></div>
            <span class="text_29">选项二</span>
            <span class="text_30">选项三</span>
          </div>
          <div class="group_6 flex-col">
            <div class="text-wrapper_17 flex-col"><span class="text_31">最热</span></div>
            <span class="text_32">最新</span>
          </div>
        </div>
        <div class="section_7 flex-col">
          <div class="section_21 flex-row justify-between">
            <span class="text_33">确认删除</span>
            <div class="image-wrapper_20 flex-col">
              <img
                class="thumbnail_45"
                referrerpolicy="no-referrer"
                src="./assets/img/FigmaDDSSlicePNG7123d105c5644f395a48ff5fc35f9c19.png"
              />
            </div>
          </div>
          <img
            class="image_1"
            referrerpolicy="no-referrer"
            src="./assets/img/FigmaDDSSlicePNG3afe3344db76886f0c3d2e3db88625f3.png"
          />
          <span class="text_34">你的项目将永久删除且无法找回，是否确认？</span>
          <div class="section_22 flex-row justify-between">
            <div class="text-wrapper_18 flex-col"><span class="text_35">取消</span></div>
            <div class="text-wrapper_19 flex-col"><span class="text_36">确认</span></div>
          </div>
        </div>
        <div class="box_49 flex-col"></div>
        <div class="box_50 flex-col"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      constants: {}
    };
  },
  methods: {}
};
</script>
<style scoped lang="css" src="./assets/index.css" />